import React, { Component } from 'react';
import styled from 'styled-components';
import media from '../styles/media';

class Content extends Component {
  render() {
    return (
      <Root>
        <AboutContainer id="About">
          <h4>About</h4>
          <h2>
            For the last three decades we have built homes with a level of
            quality that our homeowners can count on. Homes that have been
            designed and crafted to give them style, comfort and a place they
            are proud to call their own.
          </h2>
        </AboutContainer>
        <HistoryContainer>
          <HistoryImageContainer />
          <HistoryTextContainer>
            <h4>Our History</h4>
            <h2>
              The story of Trellis Properties is one of two families, two
              generations living parallel lives, coming together to create a
              legacy.
            </h2>
            <p>
              It begins 30 years ago with a roofer and a cabinet maker. They
              each started their careers as subcontractors, working on homes and
              townhomes throughout the Lower Mainland. 20 years later, their
              reputations for craftsmanship and reliability had allowed them to
              each start successful companies that built single-family and
              multi-family homes throughout the Lower Mainland.
            </p>
            <p>
              They had over the years crossed paths, but never imagined a future
              where their almost parallel lives would become one. It was only
              when their sons, who were both studying at Simon Fraser
              University, met and recognized that what their fathers had
              accomplished individually, could be united to create a legacy for
              the future.
            </p>
            <p>
              Trellis Properties was founded on the experience and expertise of
              the first generation, and the vision and vitality of the next. It
              is a story of two fathers and two sons, and a future built on the
              past.
            </p>
          </HistoryTextContainer>
        </HistoryContainer>
        <ValuesContainer>
          <ValuesImageContainer />
          <ValuesTextContainer>
            <h4>Our Values</h4>
            <h2>
              We come from humble beginnings. From hard work, learning from
              experience, and from doing things the right way.
            </h2>
            <p>
              We are a company that is founded on relationships, on trust, and
              is a place where a handshake and a promise still means something.
              We are old fashioned in our its approach, and visionary in our
              implementation. Our values come from our family roots, and it
              forms a foundation that hundreds of homeowners in the Lower
              Mainland have put their trust in for over two decades.
            </p>
          </ValuesTextContainer>
        </ValuesContainer>
        <PhilosophyContainer>
          <PhilImageContainer />
          <PhilosophyTextContainer>
            <h4>Our Philosophy</h4>
            <h2>
              As a family-owned and operated company, we understand what buying
              your own home means to you.
            </h2>
            <p>
              We know the financial commitment it takes, and the trust you put
              in a homebuilder to create a home that will not only live up to
              the dreams you have today, but also to the hopes of what home
              ownership will give you in the future. Its why we take so much
              care in designing, developing and building every one of our homes.
              Our 3 decades of experience lets us create homes that will give
              you lasting quality, enduring style, and a place that is carefully
              and thoughtfully created to be with you for a lifetime.
            </p>
          </PhilosophyTextContainer>
        </PhilosophyContainer>
        <TestimonialContainer>
          <h3>
            “Being part of a family business like ours is something very
            meaningful to us. It represents a real pride in what we’ve achieved,
            the experience gained, and the relationships built. And it reminds
            us that every day that everything we do has to live up to that
            standard.”
          </h3>
          <h4>- Paul Burmy</h4>
        </TestimonialContainer>
      </Root>
    );
  }
}

export default Content;

const HistoryImageContainer = styled.div`
  width: 100%;
  height: 435px;
  background-image: url('/assets/images/table.jpg');
  background-size: cover;
  background-position: center;
  margin-top: 60px;
  @media (min-width: ${media.sm}) {
    height: 677px;
    width: 100%;
    background-image: url('/assets/images/table.jpg');
    background-size: cover;
    background-position: center;
  }
  @media (min-width: ${media.md}) {
    width: 50%;
  }
`;

const PhilImageContainer = styled.div`
  width: 100%;
  height: 370px;
  background-image: url('/assets/images/father-son.jpg');
  background-size: cover;
  background-position: center;
  margin-top: 60px;
  @media (min-width: ${media.sm}) {
    height: 590px;
    width: 100%;
    background-image: url('/assets/images/father-son.jpg');
    background-size: cover;
    background-position: initial;
  }
  @media (min-width: ${media.md}) {
    width: 50%;
  }
`;

const AboutContainer = styled.div`
  &:before {
    content: '';
    width: 500px;
    height: 470px;
    top: 80px;
    position: absolute;
    left: -250px;
    z-index: -1;
    background-image: url('/assets/images/trellis-orange-background.png');
    background-size: cover;
    opacity: 0.06;

    @media (min-width: ${media.sm}) {
      left: 20px;
    }
  }
  @media (min-width: ${media.md}) {
    margin-bottom: 150px;
    margin-left: 10%;
    width: 800px;
  }
`;

const Root = styled.div`
  position: relative;
  height: 100%;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 155px;
  z-index: 998;
  @media (min-width: ${media.md}) {
    padding-left: 5%;
    padding-right: 5%;
  }

  @media (min-width: 1337px) {
    padding-left: 11%;
    padding-right: 11%;
  }

  h3 {
    margin-top: 60px;
    font-family: 'korolev';
    font-style: italic;
    font-weight: 300;
    font-size: 30px;
    color: #0a0203;
    letter-spacing: 0.5px;
    text-align: center;
    line-height: 42px;
  }
`;

const HistoryContainer = styled.div`
  h4 {
    margin-top: 61px;
  }
  p {
    margin-top: 35px;
  }
  @media (min-width: ${media.md}) {
    display: flex;
    margin-bottom: 200px;
    align-items: center;
  }
`;

const ValuesImageContainer = styled.div`
  width: 100%;
  height: 270px;
  background-image: url('/assets/images/construction.jpg');
  background-size: cover;
  background-position: center;
  margin-top: 60px;
  @media (min-width: ${media.sm}) {
    height: 485px;
    width: 100%;
    background-image: url('/assets/images/construction.jpg');
    background-size: cover;
    background-position: initial;
  }
  @media (min-width: ${media.md}) {
    width: 60%;
  }
`;

const ValuesContainer = styled.div`
  @media (min-width: ${media.md}) {
    align-items: center;
    margin-bottom: 200px;
    display: flex;
    div:nth-of-type(1) {
      order: 2;
    }
  }
  h4 {
    margin-top: 61px;
  }
  p {
    margin-top: 35px;
  }
`;

const ValuesTextContainer = styled.div`
  @media (min-width: ${media.md}) {
    margin-right: 64px;
    width: 36%;
  }
`;

const PhilosophyContainer = styled.div`
  @media (min-width: ${media.md}) {
    align-items: center;
    display: flex;
    margin-bottom: 280px;
    height: 700px;
  }
  h4 {
    margin-top: 61px;
  }
  p {
    margin-top: 35px;
  }
`;

const HistoryTextContainer = styled.div`
  width: 100%;
  @media (min-width: ${media.md}) {
    width: 45%;
    margin-left: 64px;
  }
`;

const PhilosophyTextContainer = styled.div`
  @media (min-width: ${media.md}) {
    margin-left: 64px;
    width: 40%;
  }
`;

const TestimonialContainer = styled.div`
  text-align: center;
  h4 {
    margin-top: 31px;
  }
  @media (min-width: ${media.md}) {
    width: 75%;
    margin: 0 auto;
    margin-bottom: 290px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Content.js